require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-financial-wellness-grant.json") })
        }
      }, "path---articles-tags-financial-wellness-grant");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-financial-wellness-grant!./.cache/json/articles-tags-financial-wellness-grant.json
// module id = 1817
// module chunks = 231608221292675